module.exports = __webpack_public_path__ + "9cdef6dab8ee7fee41b3888a0d0459e6.svg";